import storeModule from './store-module'
import { defineStore } from 'pinia'

export default defineStore('products', storeModule.createStoreModule('products'))
